const state = {
  quantityField: 1
};

const getters = {
  getQuantityField: (state, getters) => {
    if (getters.getQuantitySelection && getters.getQuantitySelection != "") {
      var qts = getters.getQuantitySelection.split(",");
      if (qts.includes(state.quantityField)) {
        return state.quantityField;
      } else {
        return qts[0];
      }
    }
    return state.quantityField;
  }
};

const mutations = {
  setQuantityField: (state, payload) => {
    state.quantityField = payload;
  }
};

const actions = {
  setQuantityField: ({ commit, getters, dispatch }, payload) => {
    // update also the qty from changeOptions
    commit("setQuantityField", payload);
    if (getters.getPersonalizationQuantityWithPrice) {
      return;
    }
    dispatch("setQuantity", { qty: payload, qtyCode: payload });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
